<template>
    <v-dialog persistent width="340" :value="isPopup">
        <div class="filesWrapper">
            <div class="popupHead">Add equipment
                <button type="button" @click="onClose">
                    <svg-sprite width="20" height="20" icon-id="close"></svg-sprite>
                </button>
            </div>
            <field
                :class-error="$v.equipment_id && $v.equipment_id.$error"
                margin="0 0 10px"
                width="300px"
                label="Equipment"
                placeholder="Select equipment"
                @updateAutocomplete="onAutocomplete($event, 'equipment_id')"
                @updateSearchText="onSearchText"
                item-text="name"
                :autocompleteValue="equipment_id"
                :items="equipments"
                :isClearable="false"
                is-autocomplete
                is-btn-autocomplete
                is-required
            ></field>
            <field
                :class-error="$v.driver_id && $v.driver_id.$error"
                margin="0 0 10px"
                width="300px"
                label="Driver"
                placeholder="Select driver"
                @updateAutocomplete="onAutocomplete($event, 'driver_id')"
                :autocompleteValue="driver_id"
                :items="drivers"
                :isClearable="false"
                is-autocomplete
                is-required
            ></field>
            <field
                :class-error="$v.receiving_data && $v.receiving_data.$error"
                margin="0 0 10px"
                width="300px"
                type="text"
                label="Receiving date"
                placeholder="Enter receiving date"
                :dateValue="receiving_data"
                @updateDate="onDate($event, 'receiving_data')"
                isNoTitle
                isDate
                is-required
            ></field>
            <div>
                <v-checkbox
                    class="equipmentCheckbox"
                    :input-value="returned"
                    label="Returned"
                    color="success"
                    hide-details
                    @change="onCheckbox($event, 'returned')"
                ></v-checkbox>
            </div>
            <field
                :class-error="$v.returned_date && $v.returned_date.$error"
                margin="10px 0 10px"
                width="300px"
                type="text"
                label="Returned date"
                placeholder="Enter returned date"
                displayFormat="YYYY-MM-DD"
                format="YYYY-MM-DD"
                :dateValue="returned_date"
                @updateTime="onDate($event, 'returned_date')"
                :pickTime="false"
                is-time
                :is-required="onReturnedDateRequired()"
            ></field>
            <field
                margin="0 0 10px"
                padding="10px 10px 0 10px"
                width="300px"
                label="Notes"
                placeholder="Text"
                :setInputValue="notes"
                @updateInput="onInput($event, 'notes')"
                is-textarea
            ></field>
            <button-groups @updateBtnClose="onClose" @updateSave="onSave"></button-groups>
        </div>
    </v-dialog>
</template>

<script>
import ButtonGroups from "@/shared/ButtonGroups/ButtonGroups";
// validations
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

export default {
	name: "EquipmentPopup",
	mixins: [ validationMixin ],
	components: {
		ButtonGroups
	},
	props: {
		equipments: Array,
		drivers: Array,
		editItem: Object
	},
	data: () => ({
		isPopup: true,
		equipment_id: null,
		driver_id: null,
		receiving_data: '',
		returned_date: '',
		notes: '',
		id: null,
		returned: false
	}),
	validations() {
		const { returned } = this.$data;
		const returned_date = returned ? { required } : {};

		return {
			equipment_id: { required },
			driver_id: { required },
			receiving_data: { required },
			returned_date,
		};
	},
	methods: {
		onReturnedDateRequired() {
			return this.returned;
		},
		onClose() {
			this.$emit('updateClose');
		},
		onAutocomplete({ value }, key) {
			this[key] = value?.id ?? value;
		},
		onSearchText(name) {
			this.$emit('updateSearchText', name);
		},
		onInput({ value }, key) {
			this[key] = value;
		},
		onDate(value, key) {
			this[key] = value;
		},
		onCheckbox(value, key) {
			this[key] = value;
		},
		onSave() {
			this.$v.$touch();
			if (!this.$v.$error) {
				const {
					equipment_id,
					driver_id,
					receiving_data,
					returned_date,
					notes,
					returned,
					id
				} = this.$data;

				const values = {
					equipment_id,
					driver_id,
					receiving_data,
					returned_date,
					notes,
					id,
					returned: Number(returned)
				};

				this.$emit('updateEquipmentList', values);
				this.onClose();
			}
		}
	},
	mounted() {
		if (this.editItem) {
			const {
				equipment_id,
				driver_id,
				receiving_data,
				returned_date,
				notes,
				returned,
				id
			} = this.editItem;

			this.equipment_id = equipment_id;
			this.driver_id = driver_id;
			this.receiving_data = receiving_data;
			this.returned_date = returned_date;
			this.notes = notes;
			this.id = id;
			this.returned = Boolean(returned);

		}
	}
};
</script>

<style scoped lang="scss">
@import "../../../Trucks/TruckForm/EquipmentPopup/EquipmentPopup";
</style>
<style lang="scss">
.equipmentCheckbox .v-label{
    font-size: 14px;
    line-height: 20px;
}
</style>
